import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { QueryBase } from 'src/app/libs/data-access/store/shared/query-base.interface';
import { PaymentState } from '../model';
import { PaymentSelectors } from '../store/payment.selectors';
import { paymentStateActions } from '../../data-access/store/payment.actions';

@Injectable({
  providedIn: 'root'
})
export class PaymentQuery implements QueryBase {
  flightOffer$ = this.paymentStore.select(PaymentSelectors.getFlightOffer);
  flightOrder$ = this.paymentStore.select(PaymentSelectors.getFlightOffer);
  loading$ = this.paymentStore.select(PaymentSelectors.getLoading);
  loaded$ = this.paymentStore.select(PaymentSelectors.getLoaded);
  errors$ = this.paymentStore.select(PaymentSelectors.getLoaded);
  
  constructor(
    private paymentStore: Store<PaymentState>,
  ) { }

  orderFlight(flightOffer: any, orderInformation: any): void { //TODO: Complete type
    this.paymentStore.dispatch(paymentStateActions.orderFlight({ flightOffer, orderInformation }));
  }

  loadFlightOffer(flightOfferId: string): void {
    this.paymentStore.dispatch(paymentStateActions.loadFlightOfferData({ flightOfferId }));
  }
}
